import { render, staticRenderFns } from "./index.vue?vue&type=template&id=82b9836a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "../student/detail.css?vue&type=style&index=0&id=82b9836a&scoped=true&lang=css&"
import style1 from "./index.css?vue&type=style&index=1&id=82b9836a&scoped=true&lang=css&"
import style2 from "./index-phone.css?vue&type=style&index=2&id=82b9836a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82b9836a",
  null
  
)

export default component.exports